import { Wave, WaveMap } from 'common/types/common';
import { CadenceEntry } from 'common/types/filters';
import { getColorForData } from 'modules/charts/utils/colors';

export const normalizeWave = (wave: Wave | CadenceEntry, index: number): Wave => {
  return {
    ...wave,
    date: new Date(wave.date),
    color: getColorForData(index),
  };
};

export const getLastWaves = (waves: Wave[]): number[] => {
  const newWaves = [...waves];
  const wavesSortedByDate = newWaves?.sort((a: Wave, b: Wave) => new Date(b.date).getTime() - new Date(a.date).getTime());
  return wavesSortedByDate.slice(0, 4).map(({ id }) => id);
};

export const sortWaveIdsByDate = (waveIds: number[], waveMap: WaveMap, ascending = true): number[] => {
  return [...waveIds].sort((a, b) => {
    const dateA = waveMap[a]?.date;
    const dateB = waveMap[b]?.date;

    if (!dateA || !dateB) return 0;

    const timeA = new Date(dateA).getTime();
    const timeB = new Date(dateB).getTime();

    return ascending ? timeA - timeB : timeB - timeA;
  });
};
